// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__1Alu5","tabs":"LayoutWrapperSideNav_tabs__1JftP","tab":"LayoutWrapperSideNav_tab__3Jd3m"};